import { get, post } from '@/api/index';
export const answerinfo = params => get(`/api/paper/v1/answerinfo`, params); // 报告页面
export const paperinfo = params => post(`/api/paper/v1/info`, params); //试卷详情
